export default __webpack_public_path__ + "static/media/sad-smiley.a066d461.svg";